import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * Returns diagnostic completion events for a student
 * (earliest SAT Math + earliest SAT English)
 */
export async function getDiagnosticEvents({ userId, firstName }) {
  const events = [];

  const userSnap = await getDoc(doc(db, "users", userId));
  if (!userSnap.exists()) return events;

  const { estimateHistory } = userSnap.data();
  if (!estimateHistory) return events;

  const sortedDays = Object.values(estimateHistory).sort(
    (a, b) => a.updatedAt?.toDate?.() - b.updatedAt?.toDate?.()
  );

  let firstMath = null;
  let firstEnglish = null;

  for (const day of sortedDays) {
    if (
      !firstMath &&
      day.source === "diagnostic" &&
      day.math?.est != null
    ) {
      firstMath = {
        student: firstName,
        action: "completed SAT Math Diagnostic",
        score: day.math.est,
        sortTime: day.updatedAt.toDate(),
      };
    }

    if (
      !firstEnglish &&
      day.source === "diagnostic" &&
      day.english?.est != null
    ) {
      firstEnglish = {
        student: firstName,
        action: "completed SAT English Diagnostic",
        score: day.english.est,
        sortTime: day.updatedAt.toDate(),
      };
    }

    if (firstMath && firstEnglish) break;
  }

  if (firstMath) events.push(firstMath);
  if (firstEnglish) events.push(firstEnglish);

  return events;
}
